import { createReducer } from '@ngrx/store';
import { on } from '@ngrx/store';
import { ActionReducer } from '@ngrx/store/src/models';
import { AdvertiserTimeZoneActions } from 'app/modules/main/store/advertiser-time-zone/advertiser-time-zone.actions';
import { AdvertiserTimeZoneState } from 'app/modules/main/store/advertiser-time-zone/advertiser-time-zone.state';

export class AdvertiserTimeZoneReducer {

  private static readonly initialState: AdvertiserTimeZoneState = {
    timeZone: '',
    timeZoneName: '',
    timeZoneLoaded: false,
  };

  private static readonly onAdvertiserTimeZoneLoaded = on(
    AdvertiserTimeZoneActions.$.advertiserTimeZoneLoaded,
    (state: AdvertiserTimeZoneState, { timeZone }) =>
      ({
        ...state,
        ...timeZone,
        timeZoneLoaded: true,
      })
  );

  private static readonly onAdvertiserTimeZoneLoadFailed = on(
    AdvertiserTimeZoneActions.$.advertiserTimeZoneLoadFailed,
    (_state: AdvertiserTimeZoneState) =>
      ({
        ...AdvertiserTimeZoneReducer.initialState,
        timeZoneLoaded: true,
      })
  );

  static reducer(): ActionReducer<AdvertiserTimeZoneState> {

    return <ActionReducer<AdvertiserTimeZoneState>>createReducer(
      AdvertiserTimeZoneReducer.initialState,
      AdvertiserTimeZoneReducer.onAdvertiserTimeZoneLoaded,
      AdvertiserTimeZoneReducer.onAdvertiserTimeZoneLoadFailed,
    );
  }

}
